module.exports = __webpack_public_path__ + "static/media/icon_filter_disable.57cf21b1.svg";